export default "__VITE_ASSET__BiswY5aH__"